<template>
  <FlotoCrudContainer
    as-table
    prepend-new-item
    :scrollable="false"
    :fetch-fn="getSummaryBaselines"
    :columns="tableColumns"
    :show-no-data="false"
    selectable
    :max-allowed-selection="1"
    @selection-change="$emit('selection-change', $event)"
  >
    <template v-slot:add-controls="{ refreshList }">
      <MRow :gutter="0" class="my-2">
        <MCol :size="6">
          <MInput
            v-model="searchTerm"
            class="search-box"
            :placeholder="$t('search')"
            @update="refreshList"
          >
            <template v-slot:prefix>
              <MIcon name="search" />
            </template>
          </MInput>
        </MCol>
      </MRow>
    </template>
    <template v-slot:createdById="{ item }">
      <td class="text-ellipsis">
        <FlotoTechnicianPicker :value="item.createdById" disabled />
      </td>
    </template>
    <template v-slot:createdTime="{ item }">
      <td class="text-ellipsis">
        <span v-if="item.createdTime">
          {{ item.createdTime | datetime }}
        </span>
        <span v-else>---</span>
      </td>
    </template>
    <template v-slot:publishedDate="{ item }">
      <td class="text-ellipsis">
        <span v-if="item.publishedDate">
          {{ item.publishedDate | datetime }}
        </span>
        <span v-else>---</span>
      </td>
    </template>
  </FlotoCrudContainer>
</template>
<script>
// import CloneDeep from 'lodash/cloneDeep'
import {
  buildFlatQualificationStructure,
  buildRelationalQualificationStructure,
} from '@data/qualification'
import { getSummaryBaselinesApi } from '../../../asset-api'
export default {
  name: 'AddBaselineForm',
  props: {
    resource: { type: Object, required: true },
    baselineData: { type: Object, default: undefined },
  },
  data() {
    this.tableColumns = [
      { name: `${this.$tc('id')}`, key: 'name' },
      {
        name: `${this.$tc('name')}`,
        key: 'displayName',
      },
      {
        name: `${this.$tc('description')}`,
        key: 'description',
      },
      {
        name: `${this.$tc('created_by')}`,
        key: 'createdById',
      },
      {
        name: `${this.$tc('created_date')}`,
        key: 'createdTime',
      },
      {
        name: `${this.$tc('published')} ${this.$tc('on')} `,
        key: 'publishedDate',
      },
    ]
    return {
      searchTerm: '',
    }
  },
  methods: {
    getSummaryBaselines(filters, searchCriterias, limit, offset) {
      return getSummaryBaselinesApi(this.resource.assetTypeId, {
        qualDetails: buildFlatQualificationStructure([
          buildRelationalQualificationStructure(
            'status',
            'equal',
            'published',
            'enum',
            'db'
          ),
          ...(this.searchTerm
            ? [
                buildRelationalQualificationStructure(
                  'displayName',
                  'contains',
                  this.searchTerm,
                  'string',
                  'db'
                ),
              ]
            : []),
          ...(this.baselineData && this.baselineData.baselineId
            ? [
                buildRelationalQualificationStructure(
                  'id',
                  'not_equal',
                  [this.baselineData.baselineId],
                  'long',
                  'db'
                ),
              ]
            : []),
        ]),
      })
      // const criterias = CloneDeep(searchCriterias)
      // const q = buildFlatQualificationStructure([
      //   buildRelationalQualificationStructure(
      //     'status',
      //     'equal',
      //     'published',
      //     'enum',
      //     'db'
      //   ),
      // ])
      // criterias.quals.push(q)
      // return getSummaryBaselinesApi(q)
    },
  },
}
</script>
